import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxAutocompleteModule, DxDataGridModule, DxScrollViewModule } from 'devextreme-angular';
import { I18nModule } from "../../../shared/i18n/i18n.module";
import { ModalModule } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PDFModule } from 'app/pdf/pdf.module';
import { ClipboardModule } from 'ngx-clipboard';
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { SubPortfolioDetailsRoutingModule } from './sub-portfolio-details-routing.module';
import { SubPortfolioDetailsComponent } from './sub-portfolio-details.component';

@NgModule({
  declarations: [SubPortfolioDetailsComponent],
  imports: [
    CommonModule,
    SubPortfolioDetailsRoutingModule,
    CommonModule,
    DxDataGridModule,
    I18nModule,
    ModalModule,
    DxScrollViewModule,
    FormsModule,
    ReactiveFormsModule,
    PDFModule,
    MaterialModule,
    ClipboardModule,
    NgxSpinnerModule,
    DxAutocompleteModule
  ]
})
export class SubPortfolioDetailsModule { }
